<template>
    <div>
        <VDropdown
            :prevent-overflow="false"
            :shown="showPopper"
            :overflow-padding="60"
            auto-boundary-max-size
            :placement="placement"
        >
            <slot />
            <template #popper>
                <TagPopperDropdown
                    :dataTree="dataTrees"
                    :isHeading="isHeading"
                    :headingText="headingText"
                    :isSearchAble="isSearchAble"
                    :isMultiple="isMultiple"
                    :singleDataTree="singleDataTrees"
                    @handleClick="handleClickMethod"
                    @SearchTag="SearchTag"
                ></TagPopperDropdown>
            </template>
        </VDropdown>
    </div>
</template>

<script setup>
import TagPopperDropdown from './TagPopperDropdown.vue';
import DrilldownList from '@/components/multidropdown/DrillDownList.vue';
import { computed, ref, inject, watch } from 'vue';
import { findParentPath } from '@/composables/globals';
const emit = defineEmits(['subNavClassList', 'clickList', 'SearchTag']);
const props = defineProps({
    dataTrees: {
        type: Array,
        required: false,
    },
    isSearchAble: {
        type: Boolean,
        required: false,
        default: false,
    },
    classes: {
        type: String,
    },
    dropdownHover: {
        type: Boolean,
        default: false,
    },
    headingText: {
        type: String,
        default: '',
    },
    isHeading: {
        type: Boolean,
        default: false,
    },
    onDiary: {
        type: Boolean,
        default: false,
    },
    OnBot: {
        type: Boolean,
        default: false,
    },
    placement: {
        type: String,
        default: '',
    },
    isMultiple: {
        type: Boolean,
        default: true,
    },
    singleDataTrees: {
        type: Array,
        required: false,
    },
    showPopper: {
        type: Boolean,
        default: false,
    },
    levelsItem: {
        type: String,
        default: '',
    },
});
// const levelsTrigger = inject('trigerLevels');
// console.log(props.singleDataTrees,'check_tag')
const active = ref(false);
const openMenu = () => {
    active.value = !active.value;
};
const onDesktop = computed(() => {
    return window.innerWidth > 768;
});
const hideDropdown = () => {
    active.value = false;
};
const triggerSelectText = ref('Select Trigger');

const handleClickMethod = (value) => {
    console.log(value, 'pathToItemClickMethod handleclick');
    emit('clickList', value);
};
const handleSubNavClickMethod = (value) => {
    // console.log('subnavclass list');
    emit('subNavClassList', value);
};

const pathToItemClickMethod = (value) => {
    console.log(value.length, 'pathToItemClickMethod length');
    if (value.length > 0) {
        let js_array = value;
        triggerSelectText.value = js_array.join(' / ');
        console.log(value, 'pathToItemClickMethod');
    }
};

const SearchTag = (v) => {
    emit('SearchTag', v);
};

/*
watch(
    props.dataTrees,
    (newValue) => {
        console.log(newValue, 'a find poath');
        console.log(levelsTrigger, 'a find poath check levels');
        if (newValue && newValue[0].levels && levelsTrigger) {
            const foundedPath = findParentPath(
                newValue,
                levelsTrigger.levelsTrigger
            );
            let js_array = foundedPath;
            triggerSelectText.value = js_array.join(' / ');
            console.log(foundedPath, 'pathToItemClickMethod 1');
        }
    },
    {
        deep: true,
        immediate: true,
    }
);
*/
</script>

<style scoped></style>
